var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47994 3.5022H5.48367V0.50366C5.48367 0.347486 5.43685 0.2245 5.34322 0.1347C5.24958 0.0448995 5.12864 0 4.98039 0C4.83213 0 4.71119 0.0448995 4.61756 0.1347C4.52392 0.2245 4.47711 0.347486 4.47711 0.50366V3.5022H1.48083C1.33258 3.5022 1.21359 3.5471 1.12386 3.6369C1.03412 3.7267 0.989258 3.84578 0.989258 3.99414C0.989258 4.15032 1.03412 4.2733 1.12386 4.3631C1.21359 4.4529 1.33258 4.4978 1.48083 4.4978H4.47711V7.49634C4.47711 7.64471 4.52392 7.76574 4.61756 7.85944C4.71119 7.95315 4.83213 8 4.98039 8C5.12864 8 5.24958 7.95315 5.34322 7.85944C5.43685 7.76574 5.48367 7.64471 5.48367 7.49634V4.4978H8.47994C8.6282 4.4978 8.74719 4.4529 8.83692 4.3631C8.92665 4.2733 8.97152 4.15032 8.97152 3.99414C8.97152 3.84578 8.92665 3.7267 8.83692 3.6369C8.74719 3.5471 8.6282 3.5022 8.47994 3.5022Z",
    fill: "#BAB7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.4ba441764d62620c670093062d3c48cd.svg";
export { ForwardRef as ReactComponent };